import React from "react";
import { DollarSign, Home, Plane, ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LangContext";

export const TrustStrip = () => {
  const { t } = useLang();
  const items = [
    { icon: DollarSign, label: "25 PLN / " + t("shein.perHour").replace("/ ", "") },
    { icon: Home, label: t("hero.b1") },
    { icon: Plane, label: t("hero.b2") },
    { icon: ShieldCheck, label: t("hero.b3") },
  ];
  return (
    <div data-testid="trust-strip" className="relative z-10 bg-[#0d1730] border-y border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4">
          {items.map((it, i) => (
            <div key={i} className="trust-item flex items-center justify-center gap-3 py-5 md:py-6 text-slate-200">
              <span className="w-9 h-9 rounded-lg bg-[#FFD166]/10 flex items-center justify-center shrink-0">
                <it.icon size={18} className="text-[#FFD166]" />
              </span>
              <span className="text-sm font-medium">{it.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
